import { render, staticRenderFns } from "./list.vue?vue&type=template&id=14dcdce2&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=14dcdce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dcdce2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TechPostItem: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/tech-post/item.vue').default})
